import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Row, Col, Form } from "react-bootstrap";

import { setPersonType } from "./actions";

function PersonType(props) {
  return (
    <div>
      <p className="lead">{props.label || "Escolha o tipo"}</p>
      <Row>
        {/* <Col>
          <Form.Check
            type="switch"
            id="pf"
            checked={props.type === 0}
            onChange={(e) => props.setPersonType(0)}
            label={<p className="text-center">Pessoa física</p>}
          />
        </Col> */}
        <Col>
          <Form.Check
            type="switch"
            id="pj"
            checked={props.type === 1}
            onChange={(e) => props.setPersonType(1)}
            label={<p className="text-center">Pessoa Jurídica</p>}
          />
        </Col>
        {props.mei ? (
          <Col>
            <Form.Check
              type="switch"
              id="mei"
              checked={props.type === 2}
              onChange={(e) => props.setPersonType(2)}
              label={<p className="text-center">MEI</p>}
            />
          </Col>
        ) : null}
      </Row>
    </div>
  );
}

const mapStateToProps = (state) => ({
  type: state.personType,
});
const mapDispatchToProps = (disptach) =>
  bindActionCreators(
    {
      setPersonType,
    },
    disptach
  );

export default connect(mapStateToProps, mapDispatchToProps)(PersonType);



// WEBPACK FOOTER //
// ./src/components/parts/person-type-component/index.jsx